<div class="{{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<div *ngIf="hasData" class="r10-screenshots-container">
			<div class="preview-rect align-center">
				<div class="info-container">
					<div
						*ngIf="!isR10"
						class="img-preview-rect"
						(click)="getPreviewScreenshot(screenshotObj.imageURL)"
						[ngStyle]="{ 'background-image': 'url(' + screenshotObj?.imageURL + ')' }"
					></div>
					<div *ngIf="isR10" class="img-preview-rect" (click)="getPreviewScreenshot(screenshotObj.imageURL)">
						<img src="{{ screenshotObj?.imageURL }}" />
					</div>
					<div class="title">{{ screenshotObj?.url }}</div>
					<div class="sub-title">{{ screenshotObj?.date }}</div>
				</div>
			</div>
			<div class="clear"></div>
			<div class="thumbnails align-center">
				<div *ngIf="screenshotsMatrix.length > 0" class="screens-outer-div align-center">
					<div
						class="screen-div thumb-box"
						*ngFor="
							let screenshots of screenshotsMatrix | paginate: { itemsPerPage: 2, currentPage: p2 };
							index as i;
							let l = count
						"
					>
						<div class="" *ngFor="let screenshot of screenshots">
							<div
								class="image"
								(click)="getScreenshot(screenshot)"
								[ngStyle]="{ 'background-image': 'url(' + screenshot.imageURL + ')' }"
							></div>
						</div>
					</div>
				</div>
				<div *ngIf="isR10" class="thumb-navs align-center">
					<pagination-template
						#p="paginationApi"
						(pageChange)="p2 = $event"
						class="ctv_featured_networks"
						*ngIf="screenshotsMatrix.length > 2"
					>
						<ul class="pager">
							<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow">
								<a *ngIf="!isR10" (click)="p.setCurrent(1)">
									<span>First</span>
								</a>
								<a *ngIf="isR10" (click)="p.setCurrent(1)">
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
											<g fill="none" fill-rule="evenodd">
												<g fill="#D8D8D8">
													<g>
														<g>
															<g>
																<path
																	d="M5.657.343L7.07 1.757 2.83 6l4.242 4.244-1.414 1.414L0 6 5.657.343zm5 0l1.414 1.414L7.83 6l4.242 4.244-1.414 1.414L5 6 10.657.343z"
																	transform="translate(-1050 -687) translate(190 110) translate(860 572) translate(0 5)"
																/>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
								</a>
							</li>
							<li
								role="button"
								*ngFor="let page of p.pages"
								[class.current]="p.getCurrent() === page.value"
								class="pages"
								style="float: left"
							>
								<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
									{{ page.label }}
								</a>
								<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
									{{ page.label }}
								</a>
							</li>
							<li [class.disabled]="p.isLastPage()" style="float: left" class="lastArrow">
								<a *ngIf="!isR10" (click)="p.setCurrent(p.getLastPage())">
									<span>Last</span>
								</a>
								<a *ngIf="isR10" (click)="p.setCurrent(p.getLastPage())">
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
											<g fill="none" fill-rule="evenodd">
												<g fill="#D8D8D8">
													<g>
														<g>
															<g>
																<path
																	d="M1.417.343L7.074 6l-5.657 5.657-1.414-1.414L4.245 6 .003 1.757 1.417.343zm5 0L12.074 6l-5.657 5.657-1.414-1.414L9.245 6 5.003 1.757 6.417.343z"
																	transform="translate(-1258 -687) translate(190 110) translate(860 572) translate(208 5)"
																/>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
									</span>
								</a>
							</li>
						</ul>
					</pagination-template>
				</div>
			</div>
			<div class="clear"></div>
			<div *ngIf="!isR10" class="thumb-navs align-center">
				<pagination-template
					#p="paginationApi"
					(pageChange)="p2 = $event"
					class="ctv_featured_networks"
					*ngIf="screenshotsMatrix.length > 2"
				>
					<ul class="pager">
						<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow">
							<a *ngIf="!isR10" (click)="p.setCurrent(1)">
								<span>First</span>
							</a>
							<a *ngIf="isR10" (click)="p.setCurrent(1)">
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
										<g fill="none" fill-rule="evenodd">
											<g fill="#D8D8D8">
												<g>
													<g>
														<g>
															<path
																d="M5.657.343L7.07 1.757 2.83 6l4.242 4.244-1.414 1.414L0 6 5.657.343zm5 0l1.414 1.414L7.83 6l4.242 4.244-1.414 1.414L5 6 10.657.343z"
																transform="translate(-1050 -687) translate(190 110) translate(860 572) translate(0 5)"
															/>
														</g>
													</g>
												</g>
											</g>
										</g>
									</svg>
								</span>
							</a>
						</li>
						<li
							role="button"
							*ngFor="let page of p.pages"
							[class.current]="p.getCurrent() === page.value"
							class="pages"
							style="float: left"
						>
							<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
								{{ page.label }}
							</a>
							<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
								{{ page.label }}
							</a>
						</li>
						<li [class.disabled]="p.isLastPage()" style="float: left" class="lastArrow">
							<a *ngIf="!isR10" (click)="p.setCurrent(p.getLastPage())">
								<span>Last</span>
							</a>
							<a *ngIf="isR10" (click)="p.setCurrent(p.getLastPage())">
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
										<g fill="none" fill-rule="evenodd">
											<g fill="#D8D8D8">
												<g>
													<g>
														<g>
															<path
																d="M1.417.343L7.074 6l-5.657 5.657-1.414-1.414L4.245 6 .003 1.757 1.417.343zm5 0L12.074 6l-5.657 5.657-1.414-1.414L9.245 6 5.003 1.757 6.417.343z"
																transform="translate(-1258 -687) translate(190 110) translate(860 572) translate(208 5)"
															/>
														</g>
													</g>
												</g>
											</g>
										</g>
									</svg>
								</span>
							</a>
						</li>
					</ul>
				</pagination-template>
			</div>
		</div>
		<div class="no-data-container r10-no_data" *ngIf="!hasData && !showLoad">
			<div class="no-data-screenshots">
				<div class="no-data-text">No Data Available</div>
			</div>
		</div>
	</div>
</div>
